// extracted by mini-css-extract-plugin
export default {"FormPaper":"EmployeeSelfEntryForm_FormPaper__Jupq7","SubmitButton":"EmployeeSelfEntryForm_SubmitButton__DvZhe"};